import styled from 'styled-components';

export const Container = styled.div<{ $open: boolean }>`
  transition: padding-top 200ms;

  &:first-child {
    padding-top: ${({ theme, $open }) => ($open ? theme.spacing(6) : 0)};
  }
`;
